module.exports = __webpack_public_path__ + "static/assets/a49781a183a18db0a1207f3e931ec022.png";